import { FC } from "react";

type ChatsIconProps = {
  fill?: string;
  width?: number;
  height?: number;
} & React.SVGProps<SVGSVGElement>;

export const ChatsIcon: FC<ChatsIconProps> = ({
  fill = "#647DAF",
  width = 13,
  height = 12,
  ...rest
}) => (
  <svg width={width} height={height} {...rest} viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.464723 0.464723C0.167167 0.762279 0 1.16586 0 1.58667V4.76C0 5.18081 0.167167 5.58438 0.464723 5.88196C0.762279 6.17953 1.16586 6.34669 1.58667 6.34669H3.17333V8.72669L5.55333 6.34669H7.13997C7.5608 6.34669 7.96436 6.17953 8.26193 5.88196C8.55949 5.58438 8.72666 5.18081 8.72666 4.76V1.58667C8.72666 1.16586 8.55949 0.762279 8.26193 0.464723C7.96436 0.167167 7.5608 0 7.13997 0H1.58667C1.16586 0 0.762279 0.167167 0.464723 0.464723ZM10.3133 4.76V3.17333H11.1067C11.5275 3.17333 11.931 3.3405 12.2286 3.63805C12.5262 3.93562 12.6933 4.33919 12.6933 4.76V7.93331C12.6933 8.35415 12.5262 8.7577 12.2286 9.05527C11.931 9.35284 11.5275 9.52 11.1067 9.52H9.52003V11.9L7.14004 9.52H5.55335C5.2844 9.52 5.03133 9.45336 4.8092 9.33513L6.21023 7.93331H7.14004C7.98165 7.93331 8.78874 7.59899 9.38388 7.00392C9.97902 6.40878 10.3133 5.60161 10.3133 4.76Z"
      fill={fill}
    />
  </svg>
);
